import { logAssert } from "@faire/web--source/common/logging";
import { createContext, useContext } from "react";
export var Context = createContext(undefined);
export var LoggedOutCategoryPageCurrentCategoryProvider = Context.Provider;
export var useLoggedOutCategoryPageCurrentCategory = function() {
    var category = useContext(Context);
    logAssert(category !== undefined, "useLoggedOutCategoryPageCurrentCategory must be used within a LoggedOutCategoryPageCurrentCategoryProvider");
    return category;
};
